import React, { useState } from "react";
import Select, { components } from "react-select";
// import { colourOptions } from "../data";
import { FiSearch } from "react-icons/fi";
import { IoMdArrowDropdown } from "react-icons/io";

const Control = ({ children, ...props }) => {
  const { selectProps } = props;
  const style = { cursor: "pointer", display: "flex", alignItems: "center" };

  return (
    <components.Control {...props}>
      {/* Replace the emoji with the search icon */}
      <FiSearch style={style} />
      {children}
    </components.Control>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      {/* Replace the dropdown icon with a custom icon (or leave as default) */}
      <IoMdArrowDropdown size={20} color={" #161439"} />
    </components.DropdownIndicator>
  );
};

const CustomSelectProps = ({
  className,
  options,
  SelectDynamicOptions,
  disabled,
  value,
  onChange,
  isMulti,
  required,
  ...props
}) => {
  const [clickCount, setClickCount] = useState(0);
  const onClick = (e) => {
    setClickCount(clickCount + 1);
    e.preventDefault();
    e.stopPropagation();
  };

  const styles = {
    control: (css) => ({ ...css, paddingLeft: "1rem" }),
  };

  console.log(options, value, "options");

  return (
    <Select
      {...props}
      options={options}
      SelectDynamicOptions={SelectDynamicOptions}
      value={value}
      onChange={onChange}
      className={className}
      isMulti={isMulti}
      components={{ Control, DropdownIndicator }} // Custom components for search and dropdown indicator
      isSearchable
      styles={styles}
      isDisabled={disabled}
      required={required}
    />
  );
};

export default CustomSelectProps;
